import React from "react";
import styled from "styled-components";

// --- Styled Components ---
const SkillsContainer = styled.div`
  display: flex;
  justify-content: space-between; 
  max-width: 700px;
  width: 100%;
  margin: 8px auto 0px auto;
  padding: 0 20px 0 50px;
  gap: 20px; 

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    padding: 0 20px;
  }

  @media print {
    max-width: 600px;
    padding-left: 20px;
  }
`;

const SkillColumn = styled.div`
  min-width: 0;

  @media screen and (min-width: 769px), print {
    flex: 0 0 auto; 
    
    &:nth-child(1) {
      max-width: 260px;
    }
    &:nth-child(2) {
      max-width: 180px;
    }
    &:nth-child(3) {
      max-width: 160px;
    }
    @media print {
       &:nth-child(1) {
        max-width: 220px;
      }
      &:nth-child(2) {
        max-width: 150px;
      }
      &:nth-child(3) {
        max-width: 120px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    flex: unset;
    width: 100%;
  }
`;

const SkillHeadline = styled.h3`
  font-size: 1.2rem;
  font-weight: normal;
  font-variant: small-caps;
  color: #538135;
  margin-top: 0px;
  margin-bottom: 10px;
`;

const SubSkillHeadline = styled.h4`
  font-size: 0.82rem;
  font-weight: normal;
  font-style: italic;
  color: #000000;
  margin-top: 0px;
  margin-bottom: 0px;

  @media print {
    margin-bottom: 3px;
  }
`;

const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
`;

const SkillItem = styled.span`
  background-color: #eeeeee;
  border-radius: 20px;
  margin-top: 3px;
  padding: 5px 12px;
  font-size: 0.85rem;
  line-height: 1.3;
  white-space: nowrap;
`;

// --- Component Logic ---
const SkillsList = ({ skills }) => {
  if (!skills || skills.length === 0) return null;

  const renderSkillContent = (skillSection) => {
    return (
      <>
        <SkillHeadline>{skillSection.headline}</SkillHeadline>
        
        {/* If subsections exist, map them (used for Technologies column) */}
        {skillSection.subsections && skillSection.subsections.length > 0 ? (
          skillSection.subsections.map((subsection, sIdx) => (
            <div key={sIdx}>
              <SubSkillHeadline>{subsection.headline}</SubSkillHeadline>
              <SkillList>
                {subsection.items?.map((skill, ssIdx) => (
                  <SkillItem key={ssIdx}>{skill}</SkillItem>
                ))}
              </SkillList>
            </div>
          ))
        ) : (
          /* If no subsections, render the main list directly (used for Tools, Concepts, etc.) */
          <SkillList>
            {skillSection.items?.map((skill, sIdx) => (
              <SkillItem key={sIdx}>{skill}</SkillItem>
            ))}
          </SkillList>
        )}
      </>
    );
  };

  return (
    <SkillsContainer>
      {skills.map((skillSection, index) => (
        <SkillColumn key={index}>
          {renderSkillContent(skillSection)}
        </SkillColumn>
      ))}
    </SkillsContainer>
  );
};

export default SkillsList;